import { HelmetProvider } from "react-helmet-async";
import { ChakraProvider, createStandaloneToast } from "@chakra-ui/react";
import { theme } from "./theme/Theme";
import { AppRoutes } from "./router/Router";
import { ModalProvider } from "../contexts/ModalContext";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { queryClient } from "../api/QueryClient";
// import { useEffect } from "react";
// import { useLnQNotifications } from "../hooks/lnq/useLnQNotifications";
// import { useLnQConfirmation } from "../hooks/lnq/useLnQConfirmation";
// import { LnQConfirmationModal } from "../components/LnQ/LnQConfirmationModal";

const { ToastContainer, toast } = createStandaloneToast(theme);

// Add the standalone toast to window so we can use it outside of react components
declare global {
  interface Window {
    toast: typeof toast;
  }
}
window.toast = toast;

const AppContent = () => {
  // const { currentLnQ, isModalVisible, handleAvailabilityResponse, resetModal } =
  //   useLnQConfirmation();
  // useLnQNotifications();

  // useEffect(() => {
  //   const handleDeepLink = (event: { url: string }) => {
  //     const { url } = event;
  //     if (url.startsWith("lnq://")) {
  //       resetModal();
  //     }
  //   };

  //   const url = window.location.href;
  //   if (url.startsWith("lnq://")) {
  //     handleDeepLink({ url });
  //   }

  //   window.addEventListener("url", handleDeepLink as any);

  //   return () => {
  //     window.removeEventListener("url", handleDeepLink as any);
  //   };
  // }, [resetModal]);

  return (
    <ChakraProvider
      theme={theme}
      toastOptions={{
        defaultOptions: {
          position: "top",
          isClosable: true,
          duration: 5000,
        },
      }}
    >
      <HelmetProvider>
        <ToastContainer />
        <ModalProvider>
          <AppRoutes />
          {/* <LnQConfirmationModal
            key={currentLnQ?.id}
            lnq={currentLnQ}
            isOpen={isModalVisible}
            onConfirm={() => handleAvailabilityResponse(true)}
            onDecline={() => handleAvailabilityResponse(false)}
          /> */}
        </ModalProvider>
      </HelmetProvider>
    </ChakraProvider>
  );
};

const App = (): JSX.Element => {
  const persister = createSyncStoragePersister({
    storage: window.localStorage,
    key: "react-query-cache",
  });

  return (
    <PersistQueryClientProvider
      persistOptions={{
        persister,
        maxAge: 1000 * 60 * 60 * 24,
        buster: "",
      }}
      client={queryClient}
    >
      <AppContent />
      <ReactQueryDevtools buttonPosition="bottom-left" initialIsOpen={false} />
    </PersistQueryClientProvider>
  );
};

export default App;
